module.exports = __webpack_public_path__ + "img/downx1.0cc50e5b.svg";